import { CityRO } from '@routellers/types/dist/city/city.ro';
import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = QueryDto;

type ResponseData = QueryRO<CityRO>;

export const query: ApiMethodDeclaration<ParamsData, ResponseData> = (params) => ({
    url: '/cities',
    method: 'GET',
    params,
});
